import { IconCircleArrowUpOutline18 } from "nucleo-ui-outline-18"

import type { Plan } from "@productlane/lib/src/browser"
import { cn, PLAN_DISPLAY_NAMES } from "@productlane/lib/src/browser"

import { useTrial } from "@/lib/useTrial"
import { shouldShowPlanPill } from "./plan-pill-visibility"

export function PlanPill({
	plan,
	className,
}: {
	plan: Plan
	className?: string
}) {
	const { effectivePlan, isTrial } = useTrial()

	if (!shouldShowPlanPill({ requiredPlan: plan, effectivePlan, isTrial })) {
		return null
	}

	return (
		<span
			className={cn(
				"inline-flex flex-none items-center gap-1 rounded-md py-0.5 pl-1.5 pr-2 text-[11px] font-medium text-green-600 ring-1 ring-inset ring-green-500/40 dark:text-green-400 dark:ring-green-500/20",
				className,
			)}
		>
			<IconCircleArrowUpOutline18
				className="h-3 w-3 flex-none"
				strokeWidth={1.25}
			/>
			{PLAN_DISPLAY_NAMES[plan]}
		</span>
	)
}
